// imove-behavior: 开始上报


export default async function(ctx) {
  const { context = {}, payload = {} } = ctx;
  const { reportIns = null } = context;
  const { eventCode = '', params = {} } = payload;
  if (reportIns?.dataReport) {
    reportIns.dataReport(eventCode, params);
  }
  return null;
}